import { render, staticRenderFns } from "./ProgramBuyerSpace.vue?vue&type=template&id=254b18f8&"
import script from "./ProgramBuyerSpace.vue?vue&type=script&lang=js&"
export * from "./ProgramBuyerSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports